export const userRoute = `${process.env.REACT_APP_SERVER_URL}/user`;
export const historicalResultsRoute = `${process.env.REACT_APP_SERVER_URL}/historicalresults`;
export const staffRoute = `${process.env.REACT_APP_SERVER_URL}/staff`;
export const pricelistRoute = `${process.env.REACT_APP_SERVER_URL}/pricelist`;
export const profileRoute = `${process.env.REACT_APP_SERVER_URL}/profile`;
export const dashboardRoute = `${process.env.REACT_APP_SERVER_URL}/dashboard`;
export const documentRoute = `${process.env.REACT_APP_SERVER_URL}/document`;